import { gql } from '@apollo/client'
import { BlockFragment } from 'app/features/shared/blocks'
import { BaseArticleBlock } from '../blocks.types'

export const FeaturedArticleBlockFragment: BlockFragment = {
  name: 'featuredArticle',
  fragment: gql`
    fragment featuredArticle on FeaturedArticle {
      id
      blockName
      blockType
      random
      article {
        id
        title
        shortDescription
        featuredImage {
          url
          alt
        }
        primaryCategory {
          name
          slug
        }
        slug
      }
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
  partialFragment: `
    ...on FeaturedArticle {
      id
      blockName
      blockType
      random
      article {
        id
        title
        shortDescription
        featuredImage {
          url
          alt
        }
        primaryCategory {
          name
          slug
        }
        slug
      }
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
}

export const FeaturedArticleBlockType = 'featuredArticle'

export interface FeaturedArticleBlock extends BaseArticleBlock {
  blockType: typeof FeaturedArticleBlockType
  random: boolean
  imagePriority?: boolean
  article: {
    id: string
    title: string
    shortDescription: string
    featuredImage?: {
      url: string
      alt: string
    }
    primaryCategory: {
      name: string
      slug: string
    }
    slug: string
  }
}
